import { colors } from '@components/theme/gen2';
import { styled } from '@mui/material';
import { rem } from 'polished';

export const RequestList = styled('div')({
  marginTop: rem(20),
  backgroundColor: colors.white,
  marginBottom: rem(20),
});
